import React, { useState, useEffect } from 'react';
import { Tabs } from 'antd';
import { ProductOutlined, TeamOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import ProduseList from './components/ProduseList';
import FurnizoriList from './Furnizor/FurnizoriList';

const { TabPane } = Tabs;

function Produse() {
  const { tab } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('produse');

  useEffect(() => {
    if (tab && (tab === 'produse' || tab === 'furnizori')) {
      setActiveTab(tab);
    } else if (tab) {
      // Dacă tab-ul nu este valid, redirecționează la tab-ul implicit
      navigate('/dashboard/achizitii/produse', { replace: true });
    }
  }, [tab, navigate]);

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    navigate(`/dashboard/achizitii/${newTab}`);
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="w-full mx-auto">
        <Tabs 
          activeKey={activeTab} 
          onChange={handleTabChange}
          size="large"
          className="bg-white rounded-lg shadow-sm px-4"
        >
          <TabPane
            tab={
              <span className="flex items-center gap-2">
                <ProductOutlined />
                Produse
              </span>
            }
            key="produse"
          >
            <ProduseList />
          </TabPane>
          
          <TabPane
            tab={
              <span className="flex items-center gap-2">
                <TeamOutlined />
                Furnizori
              </span>
            }
            key="furnizori"
          >
            <FurnizoriList />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
}

export default Produse;